import script from "./Pincode.vue?vue&type=script&setup=true&lang=js"
export * from "./Pincode.vue?vue&type=script&setup=true&lang=js"

import "./Pincode.vue?vue&type=style&index=0&id=59a27c79&scoped=true&lang=css"

import exportComponent from "D:\\Pragmasoft\\zntry.consent\\src\\Zntry.Consent.Website\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59a27c79"]])

export default __exports__